import { BrowserModule } from '@angular/platform-browser';
import { NgModule, isDevMode } from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ComumModule } from '@nsinova/comum';
import { AllusModule, getApplication } from '@nsinova/allus';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ComumModule.forRoot({
      routeAuthentication: 'auth/login',
      // TO DEPLOY
      api_base: document.location.origin

      // // TO DESENV
      // api_base: environment.production ?
      //   document.location.origin :
      //   document.location.origin.replace(':4201', '').replace('local', 'desenv').replace('http:', 'https:')
    }),
    AllusModule.forRoot()
  ],
  providers: [
    {
      provide: 'DESVIOS_API',
      useValue: isDevMode() ? environment.desvios : null
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }